import { defineMessages } from "react-intl"

const messages = defineMessages({
  removeImage: {
    id: "upload.remove-image",
    defaultMessage: "Remove image"
  },
  saveChanges: {
    id: "upload.save-changes",
    defaultMessage: "Save changes"
  },
  publish: {
    id: "upload.publish",
    defaultMessage: "Publish"
  },
  dragImage: {
    id: "upload.drag-image",
    defaultMessage:
      "Drag your image file here, or click to select an image to upload."
  },
  title: {
    id: "upload.title",
    defaultMessage: "Title"
  },
  description: {
    id: "upload.description",
    defaultMessage: "Description"
  },
  date: {
    id: "upload.date",
    defaultMessage: "Date"
  },
  dateHelp: {
    id: "upload.date-help",
    defaultMessage:
      'Please use <a href="https://support.stqry.com/hc/en-us/articles/360001175695-EDTF-Dates" target="_blank">EDTF Date Format</a>'
  },
  location: {
    id: "upload.location",
    defaultMessage: "Location"
  },
  tags: {
    id: "upload.tags",
    defaultMessage: "Tags"
  },
  tagsHelp: {
    id: "upload.tags-help",
    defaultMessage:
      "Seperate tags with a comma, e.g. My Tag, My Second Tag, Third, Etc"
  },
  creator: {
    id: "upload.creator",
    defaultMessage: "Creator"
  },
  creatorHelp: {
    id: "upload.creator-help",
    defaultMessage: "The name of the person who created this image."
  },
  license: {
    id: "upload.license",
    defaultMessage: "License"
  },
  licenseCcByHelp: {
    id: "upload.license-cc-by-help",
    defaultMessage:
      'Allow this image to be reused under the <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank">Creative Commons Attribution License (CC-BY)</a>'
  },
  licenseNoCopyrightHelp: {
    id: "upload.license-no-copyright-help",
    defaultMessage: "This image is out of copyright"
  },
  discardChanges: {
    id: "upload.discard-changes",
    defaultMessage: "Discard changes"
  },
  contribute: {
    id: "contribute.contribute",
    defaultMessage: "Contribute"
  },
  lead: {
    id: "contribute.lead",
    defaultMessage:
      "Our heritage is one of a shared experience. Help us build an archive of rich and interesting stories by adding your own thoughts and media."
  },
  leadManawatu: {
    id: "contribute.lead-manawatu",
    defaultMessage:
      "Our heritage is one of a shared experience. Help us build an archive of rich and interesting stories by adding your own thoughts and media. (Please note we are not currently accepting uploads enhanced using Artificial Intellegence (AI) tools.)"
  },
  media: {
    id: "contribute.media",
    defaultMessage: "Media"
  },
  haveArtifact: {
    id: "contribute.have-artifact",
    defaultMessage:
      "Have an interesting artifact to add to our library? Our upload tool lets you share images, video and audio with our community."
  },
  upload: {
    id: "contribute.upload",
    defaultMessage: "Upload"
  },
  article: {
    id: "contribute.article",
    defaultMessage: "Article"
  },
  writeArticle: {
    id: "contribute.write-article",
    defaultMessage:
      "Want to share a story with us? Our simple to use article writer will help you share your story with our community."
  },
  write: {
    id: "contribute.write",
    defaultMessage: "Write"
  },
  unsavedInformation: {
    id: "messages.unsaved-information",
    defaultMessage:
      "You have unsaved information, are you sure you want to leave this page?"
  },
  uploadMedia: {
    id: "contribution.upload-media",
    defaultMessage: "Upload media"
  },
  thankYou: {
    id: "contribution.thank-you",
    defaultMessage: "Thanks for your contribution"
  },
  success: {
    id: "contribution.success",
    defaultMessage: "Great! Your media was successfully updated."
  },
  viewMyMedia: {
    id: "contribution.view-my-media",
    defaultMessage: "View my media"
  },
  viewMyStory: {
    id: "contribution.view-my-story",
    defaultMessage: "View my story"
  },
  addSomethingElse: {
    id: "contribution.add-something-else",
    defaultMessage: "Add something else"
  },
  browseTheSite: {
    id: "contribution.browse-the-site",
    defaultMessage: "Browse the site"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/imageUpload.js